import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

export const FileUploadItemTextStyles: SxProps = {
  py: 0.5,
};

export const FileUploadDividerStyles: SxProps = {
  borderColor: themeColors.grey,
  height: '100%',
  ml: 2,
  my: 0,
  py: 2,
};

export const FileUploadItemStyles = (params: {
  isDownloading: boolean;
  isReady: boolean;
}): SxProps => {
  const { isDownloading, isReady } = params;
  return {
    color: isDownloading ? themeColors.grey : 'inherit',
    cursor: getCursor(isDownloading, isReady),
    overflow: 'hidden',
    pl: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
};

const getCursor = (isDownloading: boolean, isReady: boolean): CSSProperties['cursor'] => {
  if (isDownloading) {
    return 'progress';
  }
  if (isReady) {
    return 'pointer';
  }
  return 'not-allowed';
};

export const FileUploadIconWrapperStyles = (params: { isReady: boolean }): SxProps => {
  const { isReady } = params;
  return {
    '&:hover': {
      backgroundColor: isReady ? 'rgba(182,182,182,0.3)' : 'none',
    },
    alignItems: 'center',
    cursor: isReady ? 'pointer' : 'not-allowed',
    display: 'flex',
    height: '100%',
    px: 1,
  };
};
